import { MAX_UPLOAD_FILES_PER_SESSION } from '@/utils/uploadSessionLimits';

const POD_DESIGN_FLOW_BASE = '/images/ipe/pod-design-flow';

export const POD_DESIGN_FLOW_IMAGES = {
  stamp: `${POD_DESIGN_FLOW_BASE}/stamp.png`,
  flatLay: {
    template: `${POD_DESIGN_FLOW_BASE}/template.png`,
    result: `${POD_DESIGN_FLOW_BASE}/result.png`,
  },
  model: {
    template: `${POD_DESIGN_FLOW_BASE}/template-model.png`,
    result: `${POD_DESIGN_FLOW_BASE}/result-model.png`,
  },
};

export const POD_BATCH_MAX_STAMPS = MAX_UPLOAD_FILES_PER_SESSION;

export const POD_BATCH_WORKFLOW_STEPS = [
  { id: 'template', label: '选择模板', short: '①' },
  { id: 'upload', label: '上传素材', short: '②' },
  { id: 'synthesis', label: '开始合成', short: '③' },
];

function buildWorkflowSteps(templateImage, resultImage) {
  return [
    { label: '印花素材', image: POD_DESIGN_FLOW_IMAGES.stamp, transparentBg: true },
    { label: '设计模板', image: templateImage },
    { label: '合成成品', image: resultImage },
  ];
}

export function getPodBatchComposeConfig() {
  return {
    title: '商品设计',
    subtitle: '',
    workflowFlowSets: [
      {
        id: 'flatLay',
        title: '平铺套图',
        steps: buildWorkflowSteps(
          POD_DESIGN_FLOW_IMAGES.flatLay.template,
          POD_DESIGN_FLOW_IMAGES.flatLay.result,
        ),
      },
      {
        id: 'model',
        title: '模特套图',
        steps: buildWorkflowSteps(
          POD_DESIGN_FLOW_IMAGES.model.template,
          POD_DESIGN_FLOW_IMAGES.model.result,
        ),
      },
    ],
    hero: {
      caption: '印花素材 → 设计模板 → 一键合成商品展示图',
    },
  };
}
